import { toast } from "react-toastify"

const initialState = {
    hat: null,
    error: null
}

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case 'HAT_FOUND_SUCCESS':
            toast.success(`Parabéns! Encontrou - ${payload} - pode agora equipá-lo no seu perfil ao editar a sua aparência e visualizar o chapéu com mais detalhes no seu guarda-chapéus!`)
            return { ...state, ...payload }
        case 'HAT_FOUND_ERROR':
            toast.error('Parabéns! Encontrou um novo chapéu, contudo ocorreu um erro na base de dados! Para tentar obter novamente este chapéu jogue uma narrativa ou uma partida do Mundo em Notícias')
            return { ...state, ...payload }
        case 'NO_HAT_FOUND':
            return { ...state }
        case 'ADD_HATS_SUCCESS':
            toast.success(`Chapéu(s) encontrado(s) foram adicionados com sucesso ao seu guarda-chapéus no seu inventário!`)
            return { ...state }
        case 'ADD_HATS_ERROR':
            toast.error('Ocorreu um erro a adicionar o chapéu(s) que encontrou recentemente! Tente novamente mais tarde ao terminar uma partida do Mundo em Notícias ou ao jogar uma narrativa.')
            return { ...state, ...payload }
        default:
            return state
    }
}
